export default {
  name: 'Roles',
  tabTitle: 'Role',
  data: 'Data',
  fields: {
    id: 'ID',
    idValidation:
      'Invalid ID. Use only latin letters, digits and the . _ - characters. Length must be between 3 and 64.',
    name: 'Name',
    notificationEmails: 'Notification emails',
    notificationEmailsHelperText: 'Press Enter to add the email',
    notificationEmailsValidation:
      'Invalid email: %{emails}. Please correct it. |||| Invalid emails: %{emails}. Please correct them.',
    readonly: 'Readonly / Predefined',
    addRole: 'Add role',
    editRole: 'Edit role',
    deleteRoleWarning:
      'By pressing "Confirm" the role will be completely deleted from the system. Any use with this role will not be able to log in to the system and perform any actions. Please confirm.',
  },
  permissions: {
    _: 'Permissions',
    name: 'Permission',
    emptyMessage: 'There are no permissions',
    'account.block': 'Account: block',
    'account.close': 'Account: close',
    'account.list': 'Account: list',
    'account.unblock': 'Account: unblock',
    'account.update': 'Account: update',
    'account.view': 'Account: view',
    'account.resetError': 'Account: reset error',
    'account.report.balances.list': 'Account: balances',
    'account.changelog.list': 'Account → Changelog: list',
    'account.changelog.view': 'Account → Changelog: view',
    'application.list': 'Application: list',
    'application.view': 'Application: view',
    'application.terminate': 'Application: terminate',
    'approvalCase.decide': 'Approval case: decide',
    'approvalCase.view': 'Approval case: view',
    'approvalCase.list.pending.eligibleForDecision':
      'Approval case: pending list (eligible for decision)',
    'approvalCase.list.pending.all': 'Approval case: pending list (all)',
    'approvalCase.list.history.all': 'Approval case: history list',
    'approvalCase.admin': 'Approval case: admin',
    'superuser.action': 'Superuser permission',
    'individual.list': 'Individual: list',
    'individual.search.extended': 'Individual: extended search',
    'individual.view': 'Individual: view',
    'individual.create': 'Individual: create',
    'individual.update': 'Individual: update',
    'individual.delete': 'Individual: delete',
    'individual.block': 'Individual: block',
    'individual.updateRiskRating': 'Individual: update risk rating',
    'individual.updateCustomerNumber': 'Individual: update customer number',
    'individual.updatePhoneNumber': 'Individual: update phone number',
    'individual.unblock': 'Individual: unblock',
    'individual.account.alias.update': 'Individual → Account → Alias: update',
    'individual.changelog.list': 'Individual → Changelog: list',
    'individual.changelog.view': 'Individual → Changelog: view',
    'individual.account.view': 'Individual → Account: view',
    'individual.account.list': 'Indiviudal → Account: list',
    'individual.account.create': 'Individual → Account: create',
    'individual.account.update': 'Individual → Account: update',
    'individual.account.block': 'Individual → Account: block',
    'individual.account.unblock': 'Individual → Account: unblock',
    'individual.account.close': 'Individual → Account: close',
    'individual.cards.list': 'Individual → Cards: list',
    'individual.transaction.list': 'Individual → Transaction: list',
    'individual.transaction.view': 'Individual → Transaction: view',
    'individual.export': 'Individual: export',
    'individual.import': 'Individual: import',
    'individual.event.list': 'Individual → Event: list',
    'individual.tags.update': 'Individual → Tags: update',
    'individual.tags.view': 'Individual → Tags: view',
    'individual.application.list': 'Individual → Application: list',
    'individual.forceKYCLevelUpdate': 'Individual → Force KYC level update',
    'business.list': 'Business: list',
    'business.view': 'Business: view',
    'business.create': 'Business: create',
    'business.update': 'Business: update',
    'business.delete': 'Business: delete',
    'business.block': 'Business: block',
    'business.unblock': 'Business: unblock',
    'business.updateRiskRating': 'Business: update risk rating',
    'business.updateCustomerNumber': 'Business: update customer number',
    'business.changelog.list': 'Business → Changelog: list',
    'business.changelog.view': 'Business → Changelog: view',
    'business.account.view': 'Business → Account: view',
    'business.account.list': 'Business → Account: list',
    'business.account.create': 'Business → Account: create',
    'business.account.update': 'Business → Account: update',
    'business.account.block': 'Business → Account: block',
    'business.account.unblock': 'Business → Account: unblock',
    'business.account.close': 'Business → Account: close',
    'business.account.alias.update': 'Business → Account → Alias: update',
    'business.location.list': 'Business → Location: list',
    'business.location.view': 'Business → Location: view',
    'business.location.create': 'Business → Location: create',
    'business.location.update': 'Business → Location: update',
    'business.location.delete': 'Business → Location: delete',
    'business.terminal.list': 'Business → Terminal: list',
    'business.terminal.view': 'Business → Terminal: view',
    'business.terminal.create': 'Business → Terminal: create',
    'business.terminal.update': 'Business → Terminal: update',
    'business.terminal.delete': 'Business → Terminal: delete',
    'business.terminal.issueActivationCode': 'Business → Terminal: issue activation code',
    'business.terminal.issueApiKey': 'Business → Terminal: issue api key',
    'business.terminal.revokeApiKey': 'Business → Terminal: revoke api key',
    'business.terminal.getActivationCode': 'Business → Terminal: get activation code',
    'business.terminal.deactivate': 'Business → Terminal: deactivate',
    'business.employee.list': 'Business → Team member: list',
    'business.employee.view': 'Business → Team member: view',
    'business.employee.create': 'Business → Team member: create',
    'business.employee.update': 'Business → Team member: update',
    'business.employee.delete': 'Business → Team member: delete',
    'business.employee.createAccessCode': 'Business → Team member: create access code',
    'business.employee.createIdentity': 'Business → Team member: create general identity',
    'business.employee.changelog.list': 'Business → Team member → Changelog: list',
    'business.employee.changelog.view': 'Business → Team member → Changelog: view',
    'business.paymentDetails.list': 'Business → Payment details: list',
    'business.paymentDetails.view': 'Business → Payment details: view',
    'business.paymentDetails.create': 'Business → Payment details: create',
    'business.paymentDetails.update': 'Business → Payment details: update',
    'business.paymentDetails.delete': 'Business → Payment details: delete',
    'business.paymentDetails.generateQRCode': 'Business → Payment details: generate QR',
    'business.tags.update': 'Business → Tags: update',
    'business.tags.view': 'Business → Tags: view',
    'business.application.list': 'Business → Application: list',
    'business.forceKYCLevelUpdate': 'Business → Force KYB level update',
    'note.list': 'Dashboard note: list',
    'note.create': 'Dashboard note: create',
    'note.update': 'Dashboard note: update',
    'note.delete': 'Dashboard note: delete',
    'business.transaction.list': 'Business → Transaction: list',
    'business.transaction.view': 'Business → Transaction: view',
    'business.event.list': 'Business → Event: list',
    'partner.list': 'Partner: list',
    'partner.view': 'Partner: view',
    'partner.create': 'Partner: create',
    'partner.update': 'Partner: update',
    'partner.delete': 'Partner: delete',
    'partner.close': 'Partner: close',
    'partner.account.view': 'Partner → Account: view',
    'partner.account.list': 'Partner → Account: list',
    'partner.account.create': 'Partner → Account: create',
    'partner.account.update': 'Partner → Account: update',
    'partner.account.block': 'Partner → Account: block',
    'partner.account.unblock': 'Partner → Account: unblock',
    'partner.account.close': 'Partner → Account: close',
    'partner.account.alias.update': 'Partner → Account → Alias: update',
    'partner.configuration.view': 'Partner → Configuration: view',
    'partner.configuration.update': 'Partner → Configuration: update',
    'partner.transaction.list': 'Partner → Transaction: list',
    'partner.transaction.view': 'Partner → Transaction: view',
    'partner.event.list': 'Partner → Event: list',
    'partner.tags.update': 'Partner → Tags: update',
    'partner.tags.view': 'Partner → Tags: view',
    'tenant.account.list': 'Tenant → Account: list',
    'tenant.account.view': 'Tenant → Account: view',
    'tenant.account.create': 'Tenant → Account: create',
    'tenant.account.update': 'Tenant → Account: update',
    'tenant.account.alias.update': 'Tenant → Account → Alias: update',
    'tenant.account.block': 'Tenant → Account: block',
    'tenant.account.unblock': 'Tenant → Account: unblock',
    'tenant.account.close': 'Tenant → Account: close',
    'tenant.account.daySummary.list': 'Tenant → Account: day summary',
    'tenant.account.transaction.list': 'Tenant → Account → Transaction: list',
    'tenant.account.transaction.view': 'Tenant → Account → Transaction: view',
    'tenant.account.changelog.list': 'Tenant → Account → Changelog: list',
    'tenant.account.changelog.view': 'Tenant → Account → Changelog: view',
    'bank.account.list': 'Liquidity bucket: list',
    'bank.account.view': 'Liquidity bucket: view',
    'bank.account.create': 'Liquidity bucket: create',
    'bank.account.update': 'Liquidity bucket: update',
    'bank.account.daySummary.list': 'Liquidity bucket: day summary',
    'bank.account.transfer.list': 'Liquidity bucket → Transfer: list',
    'bank.account.transfer.view': 'Liquidity bucket → Transfer: view',
    'virtualLiquidityPosition.view': 'Report "Virtual Liquidity Position"',
    'solution.list': 'Solution: list',
    'solution.view': 'Solution: view',
    'solution.create': 'Solution: create',
    'solution.update': 'Solution: update',
    'solution.delete': 'Solution: delete',
    'solution.settings.view': 'Solution → Settings: view',
    'solution.settings.update': 'Solution → Settings: update',
    'solution.pricing.list': 'Solution → Pricing: list',
    'solution.pricing.view': 'Solution → Pricing: view',
    'solution.pricing.create': 'Solution → Pricing: create',
    'solution.pricing.update': 'Solution → Pricing: update',
    'solution.pricing.delete': 'Solution → Pricing: delete',
    'solution.pricing.schema.view': 'Solution → Pricing: view schema',
    'solution.pricing.changelog.list': 'Solution → Pricing → Changelog: list',
    'solution.pricing.changelog.view': 'Solution → Pricing → Changelog: view',
    'solution.product.list': 'Solution → Product: list',
    'solution.product.view': 'Solution → Product: view',
    'solution.product.create': 'Solution → Product: create',
    'solution.product.update': 'Solution → Product: update',
    'solution.product.delete': 'Solution → Product: delete',
    'solution.product.fxmapping.list': 'Solution → Product → FX mapping: list',
    'solution.handbook.view': 'Solution → Handbook: view',
    'solution.handbook.update': 'Solution → Handbook: update',
    'currency.list': 'Currency: list',
    'currency.create': 'Currency: create',
    'currency.pair.list': 'Currency → Pair: list',
    'currency.pair.update': 'Currency → Pair: update',
    'fxrates.list': 'FX rates: list',
    'fxrates.view': 'FX rates: view',
    'fxrates.create': 'FX rates: create',
    'fxrates.update': 'FX rates: update',
    'fxrates.data.view': 'FX rates → Data: view',
    'fxrates.data.update': 'FX rates → Data: update',
    'fxrates.mapping.list': 'FX rates → Mapping: list',
    'fxrates.mapping.view': 'FX rates → Mapping: view',
    'fxrates.mapping.create': 'FX rates → Mapping: create',
    'fxrates.mapping.update': 'FX rates → Mapping: update',
    'fxrates.mapping.delete': 'FX rates → Mapping: delete',
    'identity.list': 'Team: list',
    'identity.view': 'Team: view',
    'identity.create': 'Team: create',
    'identity.update': 'Team: update',
    'identity.delete': 'Team: delete',
    'identity.resetPassword': 'Team: reset password',
    'identity.changelog.list': 'Team → Changelog: list',
    'identity.changelog.view': 'Team → Changelog: view',
    'kyc.app': 'KYC/KYB: run app',
    'kyc.workflow.start': 'KYC/KYB: request level review',
    'kyc.resetProgress': 'KYC/KYB: reset level',
    'auditLog.list': 'System log: list',
    'stats.view': 'Home page (view stats)',
    'paymentService.list': 'Payment service: list',
    'paymentService.view': 'Payment service: view',
    'paymentService.create': 'Payment service: create',
    'paymentService.update': 'Payment service: update',
    'paymentService.delete': 'Payment service: delete',
    'headTransaction.list': 'Transaction: list',
    'headTransaction.view': 'Transaction: view',
    'headTransaction.revert': 'Transaction: revert',
    'headTransaction.approve': 'Transaction: approve',
    'headTransaction.cancel': 'Transaction: cancel',
    'headTransaction.issues.resolve': 'Transaction: resolve issue',
    'headTransaction.voucherCode.decrypt': 'Transaction: voucher code request',
    'headTransaction.secureCode.decrypt': 'Transaction: secure code request',
    'transaction.transfers.list': 'Transfer: list',
    'transaction.transfers.view': 'Transfer: view',
    'transaction.transfers.ledgerMapping.action': 'Transfer → Ledger mapping: action',
    'beneficiary.list': 'Beneficiary: list',
    'beneficiary.view': 'Beneficiary: view',
    'beneficiary.create': 'Beneficiary: create',
    'beneficiary.update': 'Beneficiary: update',
    'beneficiary.delete': 'Beneficiary: delete',
    'deal.list': 'Deal: list',
    'deal.view': 'Deal: view',
    'deal.code.show': 'Deal: show code',
    'deal.update': 'Deal: update',
    'report.partners.view': 'Report "Partners": view',
    'report.tenantAccounts.view': 'Report "Tenant Accounts": view',
    'report.endUsersActivity.view': 'Report "End-Users Activity": view',
    'report.endUsersActivity.export': 'Report "End-Users Activity": export',
    'report.list': 'Report: list',
    'report.view': 'Report: view',
    'report.create': 'Report: create',
    'externalSource.list': 'External source: list',
    'externalSource.view': 'External source: view',
    'externalSource.create': 'External source: create',
    'externalSource.update': 'External source: update',
    'externalSource.delete': 'External source: delete',
    'apiIdentity.list': 'API Identity: list',
    'apiIdentity.view': 'API Identity: view',
    'apiIdentity.update': 'API Identity: update',
    'apiIdentity.clearEmail': 'API Identity: clear email',
    'apiIdentity.clearPassword': 'API Identity: clear password',
    'apiIdentity.unlinkProfile': 'API Identity: unlink profile',
    'apiIdentity.activateDevice': 'API Identity: activate device',
    'apiIdentity.revokeDevice': 'API Identity: revoke device',
    'settlement.runTransfer': 'Settlement: run',
    'accountTransfer.runTransfer': 'Account transfer: run',
    'debitOrder.runTransfer': 'Debit order: run',
    'serviceCharge.runTransfer': 'Service charge: run',
    'feedback.list': 'Feedback: list',
    'feedback.statistic': 'Feedback: statistic',
    'event.actions.execute': 'Event → Actions: execute',
    'event.actions.list': 'Event → Actions: list',
    'event.list': 'Event: list',
    'event.reprocess': 'Event: reprocess',
    'integrationIdentity.view': 'Integration Identity: view',
    'localization.create': 'Message templates: create',
    'localization.update': 'Message templates: update',
    'localization.list': 'Message templates: list',
    'localization.delete': 'Message templates: delete',
    'externalProfileLink.view': 'External profile link: view',
    'externalProfileLink.list': 'External profile link: list',
    'externalProfileLink.create': 'External profile link: create',
    'externalProfileLink.update': 'External profile link: update',
    'externalProfileLink.delete': 'External profile link: delete',
    'externalProfileLink.viewAuthData': 'External profile link: view auth data',
    'externalProfileLink.event.list': 'External profile link → Event: list',
    'metrics.list': 'Metrics: list',
    'batchPayment.view': 'Batch payment: view',
    'batchPayment.list': 'Batch payment: list',
    'dashboardRole.create': 'Dashboard role: create',
    'dashboardRole.update': 'Dashboard role: update',
    'dashboardRole.delete': 'Dashboard role: delete',
    'externalSource.name.update': 'External source → Name: update',
    'externalSource.block': 'External source: block',
    'externalSource.close': 'External source: close',
    'externalSource.unblock': 'External source: unblock',
    'profileTag.create': 'Profile tag: create',
    'profileTag.delete': 'Profile tag: delete',
    'profileTag.list': 'Profile tag: list',
    'profileTag.update': 'Profile tag: update',
    'solution.settings.notification.update': 'Solution → Settings → Notificatiion: update',
    'solution.settings.notification.view': 'Solution → Settings → Notificatiion: view',
    'solution.paymentInstrumentAvailabilityRules.list':
      'Solution → Payment instrument availability rules: list',
    'solution.paymentInstrumentAvailabilityRules.view':
      'Solution → Payment instrument availability rules: view',
    'solution.paymentInstrumentAvailabilityRules.create':
      'Solution → Payment instrument availability rules: create',
    'solution.paymentInstrumentAvailabilityRules.update':
      'Solution → Payment instrument availability rules: update',
    'solution.paymentInstrumentAvailabilityRules.delete':
      'Solution → Payment instrument availability rules: delete',
    'dynamicMenu.list': 'Dynamic menu: list',
    'dynamicMenu.view': 'Dynamic menu: view',
    'dynamicMenu.create': 'Dynamic menu: create',
    'dynamicMenu.update': 'Dynamic menu: update',
    'dynamicMenu.delete': 'Dynamic menu: delete',
    'dynamicMenu.copy': 'Dynamic menu: copy',
    'externalAccountLink.create': 'External account link: create',
    'externalAccountLink.update': 'External account link: update',
    'externalAccountLink.delete': 'External account link: delete',
    'externalApplication.create': 'External application: create',
    'externalApplication.list': 'External application: list',
    'externalApplication.update': 'External application: update',
    'externalApplication.delete': 'External application: delete',
    'script.list': 'Script: list',
    'script.view': 'Script: view',
    'script.update': 'Script: update',
    'solution.legalConsent.list': 'Solution → Legal Consent: list',
    'solution.legalConsent.view': 'Solution → Legal Consent: view',
    'solution.legalConsent.create': 'Solution → Legal Consent: create',
    'solution.legalConsent.update': 'Solution → Legal Consent: update',
    'solution.legalConsent.delete': 'Solution → Legal Consent: delete',
    'individual.legalConsent.list': 'Individual → Legal Consent: list',
  },
};
